/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryTree} from '../models/DictionaryTree';
import type {Error} from '../models/Error';

export interface GetLcdSubscriptionsTrees$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLcdSubscriptionsTreesRequest = createAction<PayloadData<void>>('LCD_SUBSCRIPTIONS_DICTIONARY__GET_LCD_SUBSCRIPTIONS_TREES__REQUEST');
export const getLcdSubscriptionsTreesSuccess = createAction<PayloadData<Array<DictionaryTree>>>('LCD_SUBSCRIPTIONS_DICTIONARY__GET_LCD_SUBSCRIPTIONS_TREES__SUCCESS');
export const getLcdSubscriptionsTreesFailure = createAction<PayloadData<Error, void, true>>('LCD_SUBSCRIPTIONS_DICTIONARY__GET_LCD_SUBSCRIPTIONS_TREES__FAILURE');

export const getLcdSubscriptionsTreesActions = [
    getLcdSubscriptionsTreesRequest,
    getLcdSubscriptionsTreesSuccess,
    getLcdSubscriptionsTreesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLcdSubscriptionsTrees = (config?: GetLcdSubscriptionsTrees$Config) => {
    return {
        CALL_API: {
            types: getLcdSubscriptionsTreesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/lcd/subscriptions`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

